<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-file-text-o'"></top-line>
    <div class="back-button">
      <el-button @click="goBack" icon="el-icon-arrow-left">返回</el-button>
    </div>

    <!-- 搜索过滤栏 -->
    <el-row class="page—body">
      <el-card shadow="never" class="filter-bar">
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small" label-width="100px">
          <el-row>
            <el-col :span="14">
              <div>&nbsp;</div>
              <!-- <el-form-item label="项目名称" prop="name">
                <el-input v-model="searchForm.name" placeholder="请输入客户名称" style="width: 160px" />
              </el-form-item> -->
            </el-col>
            <el-col :span="10" style="text-align: right">
              <!-- <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch" plain>查询</el-button>
              <el-button type="info" icon="el-icon-refresh-left" size="small" @click="handleReset" plain>重置</el-button> -->
              <el-button
                type="success"
                icon="el-icon-plus"
                size="small"
                plain
                style="margin-left: 8px;"
                @click="handleCreate"
                :disabled="status === 2"
                v-if="status !== 2">
                新增费用项目
              </el-button>

              <el-button
                type="primary"
                size="small"
                @click="confirmGenerateBill"
                :loading="confirmLoading"
                :disabled="status === 2">
                {{ status === 2 ? '已确定账单' : '确认生成账单' }}
              </el-button>

              <el-button
                type="primary"
                size="small"
                plain
                style="margin-left: 8px;"
                @click="billsExport">
                导出账单
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-card>

      <!-- 明细表格 -->
      <!-- <el-table
        :data="tableData"
        border
        stripe
        v-loading="loading"
        style="width: 100%"> -->
      <el-table
        :data="tableData"
        border
        stripe
        v-loading="loading"
        style="width: 100%"
        show-summary
        :summary-method="getSummary"
        :span-method="cellSpanMethod"
      >
        <el-table-column type="index" width="65" align="center" />
        <el-table-column prop="price_name" label="收费项" width="100" show-overflow-tooltip />
        <el-table-column prop="name" label="交付批次" width="150" show-overflow-tooltip />
        <el-table-column prop="quantity" label="数量" align="center" width="90" show-overflow-tooltip />
        <el-table-column prop="delivery_time" label="交付时间" width="160" show-overflow-tooltip/>
        <el-table-column prop="billing_start_time" label="计费开始时间" width="160" show-overflow-tooltip/>
        <el-table-column prop="end_time" label="计费结束时间" width="160" show-overflow-tooltip/>
        <el-table-column prop="billable_hours" label="用量" min-width="120" align="right" />
        <el-table-column prop="unit_price" label="单价（元）"  align="right" width="120" />
        <el-table-column  prop="metering_unit" label="单位" align="center" min-width="80"  :formatter="formatMeteringUnit"/>
        <el-table-column
          prop="amount"
          label="金额（元）"
          min-width="150"
          align="right"
          :formatter="formatAmount"
        >
        </el-table-column>
        <el-table-column prop="remarks" label="备注" align="center" width="120" />
        <el-table-column
          fixed="right"
          header-align="center"
          align="center"
          show-overflow-tooltip
          width="180"
          label="操作"
        >
          <template v-slot="scope">
            <!-- 当 status === 2 时，全部显示“已锁定” -->
            <span v-if="status === 2" style="color: #999; font-size: 13px;">
              已锁定
            </span>
            <!-- 否则按 items_type 判断是否可编辑/删除 -->
            <template v-else>
              <el-button
                v-if="scope.row.items_type === 2"
                type="text"
                size="mini"
                @click="editBill(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                v-if="scope.row.items_type === 2"
                type="text"
                size="mini"
                @click="delBill(scope.row)"
              >
                删除
              </el-button>
              <span v-if="scope.row.items_type === 1" style="color: #999; font-size: 13px;">
                已锁定
              </span>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-row type="flex" justify="left" style="margin-top: 10px; margin-bottom: 18px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagination.page"
          :page-sizes="pagination.pageSizeList"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </el-row>
    </el-row>

    <!-- 新增组件 -->
    <create-bill ref="createProvider" @success="getTableData"></create-bill>
    <!-- 编辑组件 -->
    <edit-bill ref="editBill" @success="getTableData"></edit-bill>

  </d2-container>
</template>

<script>
import topLine from "@/components/save-common/topLine.vue";
import CreateBill from './CreateBill.vue';
import EditBill from './EditBill.vue';
import { MessageBox } from 'element-ui';
import util from '@/libs/util.js'

export default {
  name: "billShowDetails",
  components: {
    topLine,
    CreateBill,
    EditBill
  },
  data() {
    return {
      pageTitle: "账单明细",
      tableDataApiBase: '/api-30216/api/bills/details/', // 注意结尾斜杠
      orderId: null,
      confirmLoading: false,
      loading: false,
      billId: null,
      status:null,
      settlementPeriod:'',
      searchForm: {
        name: '',
        page: 1,
        pageSize: 10,
      },
      pagination: {
        page: 1,
        pageSize: 10,
        pageSizeList: [10, 20, 50, 100],
        total: 0
      },
      tableData: []
    };
  },
  mounted() {
    this.searchForm.page = parseInt(this.$route.query.page) || 1;
    this.searchForm.pageSize = parseInt(this.$route.query.pageSize) || 10;
    this.pagination.page = this.searchForm.page;
    this.pagination.pageSize = this.searchForm.pageSize;

    this.orderId = this.$route.query.id;
    if (!this.orderId) {
      this.$message.error('缺少账单ID参数');
      return this.goBack();
    }

    this.getTableData();
  },
  methods: {
    formatAmount(row, column, cellValue) {
      // 处理 null/undefined
      if (cellValue == null || isNaN(cellValue)) return '0.00';

      // 转为数字，保留两位小数，千分位逗号
      const num = parseFloat(cellValue).toFixed(2);
      return Number(num).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    // 合计行单元格合并
    cellSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 判断是否是合计行（rowIndex为-1表示合计行）
      if (rowIndex === -1) {
        // 前10列合并处理
        if (columnIndex < 10) {
          // 第一列显示"合计"文本，其他列不显示内容并合并
          return [1, columnIndex === 0 ? 10 : 0];
        }
      }
    },
    getSummary(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const key = column.property;
        if (key === 'amount') {
          const total = data.reduce((sum, item) => {
            const value = Number(item.amount);
            return sum + (isNaN(value) ? 0 : value);
          }, 0);

          sums[index] = total.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
     formatMeteringUnit(row, column, cellValue) {
      const unitMap = {
        1: '台·日',
        2: '卡·时',
        3: 'T·月',
        4: '台·月'
      };
      return unitMap[cellValue] || '未知单位';
    },
    goBack() {
      this.$router.go(-1);
    },
    // handleReset() {
    //   this.searchForm = {name: '', page: 1, pageSize: this.pagination.pageSize };
    //   this.pagination.page = 1;
    //   this.getTableData();
    // },
    // handleSearch() {
    //   this.pagination.page = 1;
    //   this.getTableData();
    // },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.searchForm.pageSize = size;
      this.getTableData();
    },
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.searchForm.page = page;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      const url = this.tableDataApiBase + this.orderId;

      this.$axios.get(url, {
        params: {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }
      })
        .then(response => {
          this.billId = response.data.bill_id;
          this.status= response.data.status;
          console.log(this.status);
          this.settlementPeriod = response.data.settlement_period; // 新增
          this.tableData = response.data.items || [];
          this.pagination.total = response.total || this.tableData.length;
        })
        .catch(err => {
          console.error('获取账单明细失败:', err);
          this.$message.error('获取账单明细失败');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCreate() {
      if (!this.billId) {
        this.$message.warning('账单信息未加载完成，请稍后重试');
        return;
      }
       this.$refs.createProvider.openDialog(this.billId, this.settlementPeriod);
    },
    editBill(row) {
      console.log(row);
      if (!row.hasOwnProperty('id')) {
        console.error('【数据结构错误】账单明细项缺少 id 字段！当前行数据：', row);
        this.$message.error('数据异常，请联系管理员');
        return;
      }
      console.log('row.id', row.id);
      const id = row.id;
      this.$refs.editBill.openDialog(id);
    },
    delBill(row) {
      var id = null;
      var billId = this.billId;

      if (!row) {
        this.$message.warning('数据异常');
        return;
      }

      if (row.id !== undefined && row.id !== null) {
        id = row.id;
      } else if (row.item_id !== undefined && row.item_id !== null) {
        id = row.item_id;
      }

      if (!id) {
        this.$message.warning('缺少 ID，无法删除');
        console.warn('删除失败的行：', row);
        return;
      }

      MessageBox.confirm('确定删除该条记录吗？', '提示', { type: 'warning' })
        .then(function() {
          // 使用路径传 id
          this.$axios.delete('/api-30216/api/bill-other-items', {
            params: {
              id:id,
              bill_id: billId
            }
          }).then(function(res) {
            if (res.code === 200) {
              this.$message.success('删除成功');
              this.getTableData();
            } else {
              this.$message.error(res.message || '删除失败');
            }
          }.bind(this)).catch(function(err) {
            this.$message.error('删除请求失败');
            console.error(err);
          }.bind(this));
        }.bind(this))
        .catch(function() {
          // 取消
        });
    },
    //确认生成帐单
    confirmGenerateBill() {
      if (!this.billId) {
        this.$message.warning('账单 ID 不存在');
        return;
      }

      MessageBox.confirm('确定要确认生成账单吗？此操作不可撤销', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        // 用户点击确定
        this.confirmLoading = true;
        this.$axios.get(`/api-30216/api/bills/confirm/${this.billId}`)
          .then((res) => {
            this.confirmLoading = false;
            if (res.code === 200) {
              this.$message.success('确认成功！');
              this.getTableData();
            } else {
              this.$message.error(res.message || '确认失败');
            }
          })
          .catch((err) => {
            this.confirmLoading = false;
            this.$message.error('请求失败');
            console.error(err);
          });
      }, () => {
        // 用户点击取消
        this.$message.info('已取消');
      });
    },
    //导出账单
    async billsExport() {
      // 1. 校验 billId
      if (!this.billId) {
        this.$message.warning('账单 ID 不存在');
        return;
      }
      const url = `/api-30216/api/bills/export/${this.billId}`;
      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${util.cookies.get('token')}`,
            'Accept': 'application/octet-stream'
          }
        });

        // 2. 检查响应状态
        if (!response.ok) {
          let errorMsg = `导出失败：${response.status} ${response.statusText}`;

          const contentType = response.headers.get('Content-Type');
          try {
            if (contentType && contentType.includes('application/json')) {
              const errorJson = await response.json();
              errorMsg = errorJson.msg || errorJson.message || errorMsg;
            } else {
              const errorText = await response.text();
              if (errorText) errorMsg = errorText;
            }
          } catch (e) {
            console.warn('无法解析错误响应', e);
          }
          throw new Error(errorMsg);
        }

        // 3. 获取 blob 和响应头
        const contentDisposition = response.headers.get('Content-Disposition');
        const contentType = response.headers.get('Content-Type');
        const blob = await response.blob();

        // 4. 解析文件名（优先使用 filename*=UTF-8''）
        let filename = '账单文件.xlsx'; // 默认名兜底
        if (contentDisposition) {
          const utf8FilenameMatch = contentDisposition.match(/filename\*=UTF-8''(.+)/i);
          if (utf8FilenameMatch) {
            try {
              filename = decodeURIComponent(utf8FilenameMatch[1]);
            } catch (e) {
              console.error('解码 filename* 失败', e);
            }
          } else {
            const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1];
            }
          }
        }

        // 5. 创建下载链接
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        this.$message.success('导出成功');
      } catch (error) {
        console.error('导出账单失败：', error);
        this.$message.error(error.message || '导出失败，请稍后重试');
      }
    }

  }
};
</script>

<style scoped lang="scss">
.page—body {
  margin: 20px;
}
.filter-bar {
  margin-bottom: 15px;
}
.back-button {
  margin-left: 20px;
}

/* 添加合计行加粗样式 */
::v-deep .el-table__footer-wrapper .el-table__cell {
  font-weight: bold;
}
</style>
